var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23877 20.001C6.02654 20.9961 6.74352 22.0444 7.38451 23.1381C7.9318 24.1668 8.15995 24.8643 8.55991 26.1037C8.8052 26.7885 9.02689 26.9929 9.50353 26.9929C10.0229 26.9929 10.2586 26.6452 10.4406 26.1075C10.8187 24.937 11.1153 24.0437 11.5834 23.1997C12.5017 21.5701 13.6429 20.122 14.7642 18.7303C15.0678 18.3364 17.0304 16.0417 17.914 14.2311C17.914 14.2311 19 12.2421 19 9.46438C19 6.86605 17.929 5.06396 17.929 5.06396L14.8456 5.8825L12.973 10.7713L12.5098 11.4454L12.4171 11.5675L12.2939 11.7204L12.0777 11.9646L11.7686 12.2708L10.1011 13.6174L5.93227 16.0035L5.23877 20.001Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.935974 13.8965C1.95344 16.2002 3.91549 18.2253 5.24296 20.0024L12.2938 11.7233C12.2938 11.7233 11.3005 13.0111 9.49859 13.0111C7.49149 13.0111 5.87004 11.4224 5.87004 9.41907C5.87004 8.04531 6.70381 7.10156 6.70381 7.10156L1.91752 8.37284L0.935974 13.8964V13.8965Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3726 0.425855C14.7143 1.17428 16.7187 2.7455 17.931 5.06242L12.296 11.7188C12.296 11.7188 13.1297 10.758 13.1297 9.3928C13.1297 7.34286 11.3883 5.81143 9.50713 5.81143C7.72818 5.81143 6.70648 7.09706 6.70648 7.09706V2.9036L12.3726 0.425781V0.425855Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22766 3.36691C3.62631 1.70814 6.08741 0 9.48039 0C11.1266 0 12.3668 0.428396 12.3668 0.428396L6.7012 7.10064H2.68708L2.22766 3.36698V3.36691Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.936047 13.897C0.936047 13.897 0 12.0799 0 9.44762C0 6.95973 0.97568 4.78502 2.22768 3.36719L6.7044 7.1015L0.936047 13.897Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.74bd3d268a0e97c37734086789c3fc15.svg";
export { ForwardRef as ReactComponent };